<template>
  <Dialog ref="dialog" title="Edit Document">
    <v-form @submit.prevent="save" v-model="valid">
      <v-text-field
          autofocus
          label="Name"
          filled
          v-model="document.name"
          :rules="[v => !!v.trim() || 'Name is required']"
      ></v-text-field>

      <p class="mb-0"><b>Conversion mode: </b>{{mode}}</p>
      <p class="mb-0"><b>Font family: </b>{{fontFamily}}</p>
      <p class="mb-0"><b>Font size: </b>{{fontSize}}</p>
      <p class="mb-0"><b>Line spacing: </b>{{lineSpacing}}</p>
      <p class="mb-0"><b>Mark unknown words: </b>{{document.markUnknown ? 'Yes' : 'No'}}</p>
      <p class="mb-0"><b>Preserve text formatting: </b>{{document.preserveFormat ? 'Yes' : 'No'}}</p>
    </v-form>

    <v-divider class="my-4"></v-divider>

    <div class="d-flex mt-2">
      <v-spacer></v-spacer>

      <v-btn text @click="$refs.dialog.close()">
        Cancel
      </v-btn>

      <v-btn
          text
          color="primary"
          :loading="saving"
          @click="save"
      >
        Save
      </v-btn>
    </div>
  </Dialog>
</template>

<script>
import { NoahTextAPI } from '@/common/noahtext-api';
import { MODES } from '@/common/util';
import Dialog from '@/components/general/Dialog';

export default {
  name: "DocumentEditDialog",
  components: { Dialog },
  props: {
    document: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    saving: false,
    valid: false
  }),
  computed: {
    mode() {
      for (const mode of MODES()) {
        if (
            mode.value.highlight === this.document.highlight &&
            mode.value.vowel === this.document.vowel
        ) {
          return mode.text;
        }
      }
      return MODES()[0].text;
    },
    fontFamily() {
      if (this.document.fontFamily !== null) {
        return this.document.fontFamily;
      } else {
        return 'Keep Original';
      }
    },
    fontSize() {
      if (this.document.fontSize !== null) {
        return this.document.fontSize;
      } else {
        return 'Keep Original';
      }
    },
    lineSpacing() {
      if (this.document.lineSpacing !== null) {
        return this.document.lineSpacing
      } else {
        return 'Keep Original'
      }
    }
  },
  methods: {
    open() {
      this.$refs.dialog.open();
    },
    close() {
      this.$refs.dialog.close();
    },
    async save() {
      if (!this.valid) return;

      this.saving = true;
      const updated = await NoahTextAPI.updateDocument(this.document);
      this.$emit('save', updated);
      this.$refs.dialog.close();
      this.saving = false;
    }
  }
}
</script>

<style scoped>

</style>
